import React, { FC } from 'react'

import SVGUniqueID from 'react-svg-unique-id'

import { colors as Colors } from '../../themes/Colors'

import { SVGComponentProps } from '../type'

interface IconProps extends SVGComponentProps {
  status: boolean
}

const PhoneCallIcon: FC<IconProps> = ({
  width = 24,
  height = 24,
  status = false,
  ...others
}) => {
  const fill = status ? Colors.cerulean : Colors.cement
  return (
    <SVGUniqueID>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill={fill}
        viewBox="0 0 24 24"
        {...others}
      >
        <path
          fill={fill}
          fillRule="evenodd"
          d="M16.167 1H7.833C6.427 1 5.75 1.981 5.75 3.5v17c0 1.519.677 2.5 2.083 2.5h8.334c1.406 0 2.083-.981 2.083-2.5v-17c0-1.519-.677-2.5-2.083-2.5zM7.139 19V4h9.722v15H7.14z"
          clipRule="evenodd"
        ></path>
        <path
          fill={fill}
          fillRule="evenodd"
          d="M7 4v15h10V4H7z"
          clipRule="evenodd"
          opacity="0.3"
        ></path>
        <path
          fill={fill}
          fillRule="evenodd"
          d="M12 22a1 1 0 100-2 1 1 0 000 2z"
          clipRule="evenodd"
        ></path>
      </svg>
    </SVGUniqueID>
  )
}

export { PhoneCallIcon }
